const numberFormatter = new Intl.NumberFormat(
	navigator.language
);

export function urlSafe( title ) {
	return title
		.replace( /\s/g, '-' )
		.replace( /\?|"/g, '' )
		.toLowerCase();
}

export function numberToDisplayFormat( number ) {
	return numberFormatter.format( number );
}

export function intVal( s, fallback = null ){
	const n = Number( s );

	return Number.isInteger( n ) ? n : fallback;
}

export function nl2br( str ) {
	if ( typeof str === 'undefined' || str === null ) {
		return '';
	}

	const breakTag = '<br />';

	return ( str + '' ).replace( /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2' );
}
